import { Box, styled } from '@mui/material';
import PlanUnitSelector from 'components/shared/PlanUnitSelector';
import { DateNavigation } from 'components/shared';

import { PlanUnitMix } from 'components/types';

import MenuButton from 'components/shared/MenuButton';
import { useTranslation } from 'react-i18next';
import { ClaimsAction } from '../types';

const StyledHeader = styled(Box)`
  z-index: 40;
  width: 100%;
  min-height: 50px;
  background: white;
`;

const Top = styled(Box)`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 20px;
  position: relative;

  .MuiAutocomplete-root {
    min-width: 200px;
  }
`;

interface HeaderProps {
  selectedDate: Date;
  selection?: any[];
  showActions?: boolean;
  showPlanUnitSelector?: boolean;
  onAction?: (action: ClaimsAction) => void;
  onSelectedDate: (date: Date) => void;
  onSelectPlanUnit?: (options: PlanUnitMix[]) => void;
}

const Header = (props: HeaderProps) => {
  const {
    onAction,
    onSelectedDate,
    onSelectPlanUnit,
    selectedDate,
    selection = [],
    showActions,
    showPlanUnitSelector
  } = props;

  const { t } = useTranslation('common');

  return (
    <StyledHeader component="header">
      <Top>
        {showPlanUnitSelector && onSelectPlanUnit ? (
          <PlanUnitSelector onSelected={onSelectPlanUnit} />
        ) : (
          <Box />
        )}
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)'
          }}
        >
          <DateNavigation
            defaultPeriod={'month'}
            selectedDate={selectedDate}
            setSelectedDate={onSelectedDate}
          />
        </Box>
        {showActions && (
          <MenuButton
            label={t('actions')}
            disabled={selection.length === 0}
            options={[
              {
                label: t(`travelExpenseClaims.actions.${ClaimsAction.APPROVE}`),
                onClick: () => onAction?.(ClaimsAction.APPROVE)
              },
              {
                label: t(`travelExpenseClaims.actions.${ClaimsAction.REJECT}`),
                onClick: () => onAction?.(ClaimsAction.REJECT)
              }
            ]}
          />
        )}
      </Top>
    </StyledHeader>
  );
};

export default Header;
